module.exports = __webpack_public_path__ + "img/amibo2.7ce67d47.png";